<div class="modal-header">
  <h4 class="modal-title">{{ data.title }}</h4>
  <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title"
    (click)="modal.dismiss('Cross click')">
  </button>
</div>
<form [formGroup]="form" (ngSubmit)="modal.close(form.value)">
  @if (data.formInputs) {
    <div class="modal-body">
      @if (data.body) {
        <div [innerHtml]="data.body">
        </div>
      }
      @for (input of data.formInputs; track input) {
        <div class="form-group">
          <label [for]="input.controlName" [ngClass]="{'required' : input.required}">{{ input.label }}</label>
          @if (input.helper) {
            <small class="helper"> {{ input.helper }}</small>
          }
          @if (input.type != 'select') {
            <span>
              @if (input.type == 'file' && data.fileKey) {
                <div class="form-group">
                  <div class="input-group custom-file-button">
                    <label id="upload-btn-modal" class="input-group-text" for="image">Choose/Change</label>
                    <input
                      id="file-name"
                      readonly
                      type="text"
                      class="form-control"
                      [formControlName]="data.fileKey"
                      [placeholder]="placeholder"/>
                      <input
                        hidden
                        type="file"
                        class="form-control"
                        id="image"
                        (change)="onInputChange($event)"/>
                      </div>
                    </div>
                  } @else {
                    <input
                      [formControlName]="input.controlName"
                      class="form-control"
                      [type]="input.type"
                      [placeholder]="input.label"
                      [attr.maxlength]="input.maxLength ?? 100"
                      (change)="onInputChange($event)"
                      [attr.readonly]="input.readonly"
                      [ngClass]="{ 'is-invalid': form.get(input.controlName)!.touched && form.get(input.controlName)!.hasError('pattern') }">
                      @if (input.controlName === 'email' && form.get(input.controlName)?.hasError('pattern')) {
                        <span>
                          <div class="alert alert-danger m-1 d-flex align-items-center" role="alert">
                            <fa-icon [icon]="faExclamationTriangle"></fa-icon>
                            {{ input.errorMessage }}
                          </div>
                        </span>
                      }
                    }
                  </span>
                }
                @if (input.type == 'select') {
                  <span>
                    <select [formControlName]="input.controlName" class="form-select" aria-label="Default select example">
                      <option selected disabled>Select type...</option>
                      @for (option of input.options; track option; let i = $index) {
                        <option [value]="option.value">{{ option.label }}</option>
                      }
                    </select>
                  </span>
                }
              </div>
            }
          </div>
        }
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary"
          (click)="modal.dismiss(false)">{{ data.cancelBtnText }}</button>
          <button type="submit" class="btn btn-primary"
          [disabled]="!form.valid || form.pristine">{{ data.confirmBtnText }}</button>
        </div>
      </form>
